import useSWR, { SWRConfiguration } from "swr";
import { getProspectReference } from "@utils/storage";
import { IEirSalesOfferAddon } from "@modules/eirSalesFacade/interfaces/models/IEirSalesOfferAddon";
import { getEirSalesOfferAddons } from "@modules/eirSalesFacade/apis/getEirSalesOfferAddons";

export const useOfferAddons = (offerId?: number, options: SWRConfiguration = {}) => {
    const prospectReference = getProspectReference();

    return useSWR<IEirSalesOfferAddon[]>(
        prospectReference && offerId ? ["useOfferAddon", prospectReference, offerId] : null,
        {
            fetcher: () => offerId && getEirSalesOfferAddons(prospectReference, offerId),
            shouldRetryOnError: (error) => error.status !== 404,
            revalidateOnFocus: false,
            ...options,
        }
    );
};
